/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MaritalStatus {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  IN_DOMESTIC_PARTNERSHIP = 'IN_DOMESTIC_PARTNERSHIP',
}
